import { StylesConfig } from "react-select";

export const selectStyles: StylesConfig = {
  container: (styles) => ({
    ...styles,
    font: "var(--font-s)",
  }),
  control: (styles) => ({
    ...styles,
    backgroundColor: "var(--color-input-bg)",
    boxShadow: "none",
    borderColor: "var(--color-input-border)",
    ":hover": {
      ...styles[":hover"],
      borderColor: "var(--color-input-border)",
    },
  }),
  menuList: (styles) => {
    return {
      ...styles,
      backgroundColor: "var(--color-input-bg)",
      padding: "0px",
      borderRadius: "4px",
    };
  },
  option: (styles, { isSelected }) => {
    return {
      ...styles,
      backgroundColor: isSelected ? "#bf1884" : undefined,
      color: isSelected ? "#ffffff" : undefined,
      ":active": {
        ...styles[":active"],
        backgroundColor: "#bf1884",
        color: "#ffffff",
      },
      ":hover": {
        ...styles[":hover"],
        backgroundColor: "#bf1884",
        color: "#ffffff",
      },
    };
  },
  singleValue: (styles) => {
    return {
      ...styles,
      color: "var(--color-input-text)",
    };
  },
  indicatorSeparator: (styles) => ({
    ...styles,
  }),
  menuPortal: (styles) => ({ ...styles, zIndex: "var(--z-index-dropdown-menu)" }),
};
